import { useEffect, useRef, useState } from "react";
import "./home.css";
import Testimonial from "../components/testimonial";
import Reach from "../components/reach";
import { useScroll, motion, useSpring, useTransform } from "motion/react";
import PopForm from "../components/popForm";
import axios from "axios";

export default function Home(){
      useEffect(() => {
          window.scrollTo(0, 0);
          return () => {
              window.scrollTo(0, 0);
          };
      }, []);
    
    const {scrollY} = useScroll()
    const rotate = useTransform(
      scrollY,
      [0, 300],
      [0, 310],
      { clamp: false }
    )

    const scrollRefRate = useRef(null)
    const scrollRefAbout = useRef(null)
    const scrollRefWhy = useRef(null)
    const scrollRefBuy = useRef(null)
    const scrollRefWork = useRef(null)
    // const scrollRefReach = useRef(null)
    
    const [pop, setPop] = useState(sessionStorage.getItem('pop'))
    const closePop = ()=>{
      sessionStorage.setItem('pop', true);
      setPop(true)
    }

    const [rate, setRate] = useState(null)

    useEffect(()=>{
        const getRate = async()=>{
            const rateData = await axios.get("https://script.google.com/macros/s/AKfycbw3CdF38tRgiwseHL2kGnzZY6yr8AR7NyGP6iGP108GgoOXrE-xLbg4lS2ZHgUaT3eY_A/exec")
            if(rateData.status){
                setRate(rateData.data.rate)
            } 
        }

        getRate()
    },[])
    return(
        <>
        <div className="wrapper">
          <section className="container homeLanding">
            <aside>
              <p>Reach Us Now</p>
              <img 
                src="../images/reach.svg" 
                alt="-->"
                style={{width:"2rem"}}
              />
              <button className="button-50" >Click Here</button>
            </aside>
            <header>
              <h1>Release your <br/>Gold Today</h1>
              <p>We help you in releasing your pledged gold at ease.</p>
            </header>
            <figure className="landingJewell">
              <img src="../images/jewell_1.png" alt="jewell"/>
            </figure>
            <figure className="landingDecor">
              <motion.img 
              id="scroll-indicator"
              style={{
                  rotate
              }}
              src="../images/flower_1.svg" alt="decor"/>
            </figure>
          </section>
          <section className="container rateLanding">
            <figure className="flower2">
              <img src="../images/flower_2.png" alt="flower"/>
            </figure>
            <div ref={scrollRefRate} style={{width:"100%", display:"flex", justifyContent:"center"}}>
              <motion.main
                initial={{ opacity: 0, translateY:100, }}
                whileInView={{ opacity: 1,translateY:0  }}
                viewport={{ root: scrollRefRate, once:true }}
                transition={{duration:.5, delay:0.25}}
              >
                <figure>
                  <img src="../images/gold.png" alt="gold Rate"/>
                </figure>
                <p>Today Gold Rate<br/>
                  <span>Rs.{rate?rate:"****"}</span>
                  per gram
                </p>
              </motion.main>
            </div>
          </section>
          <section className="container homeAbout">
            <main ref={scrollRefAbout}>
            <motion.main
                initial={{ opacity: 0, translateY:100, }}
                whileInView={{ opacity: 1,translateY:0  }}
                viewport={{ root: scrollRefAbout, once:true }}
                transition={{duration:.5, delay:0.25}}
              >
              <figure>
                <img src="../images/homeAbout.png" alt="moneyBag"/>
              </figure>
              <article>
                <h2>About Aurum</h2>
                <p>The Aurum Gold Company was established in the year 2024. Aurum Gold is an ISO 9001:2015 certified company. We buy all types of gold coins, jewelry, and biscuits and lend money to release pledged gold from financial institutes/pawns and brokers/NBFCs. We offer instant spot cash for gold and silver. Selling gold at Aurum Gold Company is fast, simple, and easy.</p>
                <h3>Pledged Gold are saved</h3>
                <span/>
              </article>            
              </motion.main>
            </main>
            <figure className="decor_1">
              <motion.img
              id="scroll-indicator"
              style={{
                  rotate
              }}
               src="../images/shape_1.png" alt="shape"/>
            </figure>
          </section>
          <Testimonial/>
          <section className="container homeWhy">
            <div ref={scrollRefWhy} style={{width:"100%"}}>
            <motion.main
              initial={{ opacity: 0, translateY:100, }}
              whileInView={{ opacity: 1,translateY:0  }}
              viewport={{ root: scrollRefWhy, once:true }}
              transition={{duration:.5, delay:0.25}}>
              <figure className="why">
                <img src="../images/jewell_3.png" alt="jewell_3.png"/>
              </figure>
              <article>
                <h2>Why Choose Aurum</h2>
                <ul>
                  <li>Expert Appraisal</li>
                  <li>Fair Prices</li>
                  <li>Cash for Unwanted Items</li>
                  <li>Declutter and Simplify</li>
                  <li>Capitalize on High Gold Prices</li>
                  <li>Environmentally Friendly</li>
                </ul>
                <p>To know More about Aurum</p>
                
                <button className="button-50 whyBtnPos" >Click Here</button>

              </article>
            </motion.main>
            </div>
          </section>
          <section className="container homeBuy">
            <h2>We Buy</h2>
            <div ref={scrollRefBuy} style={{width:"100%"}}>
            <motion.aside
              initial={{ opacity: 0, translateY:100, }}
              whileInView={{ opacity: 1,translateY:0  }}
              viewport={{ root: scrollRefBuy, once:true }}
              transition={{duration:.5, delay:0.25}}
            >
              <div>
                <figure>
                  <img 
                    src="../images/jewellery.png" 
                    alt="jewellery"
                    style={{width:"90%", marginBottom:"10%"}}
                  />
                </figure>
                <p>Gold Jewellry</p>
              </div>

              <div>
                <figure>
                  <img 
                    src="../images/coin.png" 
                    alt="jewellery"
                    style={{width:"100%"}}
                  />
                </figure>
                <p>Gold Coins</p>
              </div>

              <div>
                <figure>
                  <img 
                    src="../images/bullion.png" 
                    alt="jewellery"
                    style={{width:"90%", marginBottom:"10%"}}
                  />
                </figure>
                <p>Gold Bullion</p>
              </div>
            </motion.aside>
            </div>
          </section>
          <section className="container homeProcess">
            <h2>How It Works</h2>
            <div ref={scrollRefWork} style={{width:"100%"}}>
            <motion.main
              initial={{ opacity: 0, translateY:100, }}
              whileInView={{ opacity: 1,translateY:0  }}
              viewport={{ root: scrollRefWork, once:true }}
              transition={{duration:.5, delay:0.25}}
            >
              <aside>
                <figure>
                  <img src="../images/Evaluation.png" alt=""/>
                </figure>
                <h3>Evaluation</h3>
                <p>Bring your old gold items to one of our locations for evaluation by our expert appraisers.</p>
              </aside>
              <aside>
                <figure>
                  <img src="../images/Appraisal.png" alt=""/>
                </figure>
                <h3>Appraisal</h3>
                <p>Our appraisers will assess the purity and weight of your gold items and provide you with a quote based on current market prices.</p>
              </aside>
              <aside>
                <figure>
                  <img src="../images/Acceptance.png" alt=""/>
                </figure>
                <h3>Acceptance</h3>
                <p>Once you accept our offer, we’ll complete the necessary paperwork and provide you with immediate payment.</p>
              </aside>
              <aside>
                <figure>
                  <img src="../images/Confidentiality.png" alt=""/>
                </figure>
                <h3>Confidentiality</h3>
                <p>Rest assured that your transaction is handled with the utmost confidentiality and professionalism.</p>
              </aside>
            </motion.main>
            </div>
          </section>
          <Reach/>
        </div>
        {pop?null:<PopForm close={closePop}/>}
        </>
    )
}